import React, { useState } from "react";
import { Box } from "@mui/material";
import interactiveViewersStyle from "./interactiveViewersStyle";
import ModelHeader from "./components/ModelHeader";
import ToggleButton from "./components/ToggleButton";
import ViewerContent from "./components/ViewerContent";
import handleToggle from "../../utils/handleToggle";
import handleFullscreenVC from "../../utils/handleFullscreenVC"
import handleFullscreenXeokit from "../../utils/handleFullscreenXeokit";

const InteractiveViewers = () => {
  const classes = interactiveViewersStyle();
  const [activeView, setActiveView] = useState("IFC");

  return (
    <Box id= "viewerToggle" className={classes.container}>

      {/* Header */}
      <ModelHeader />

      {/* Toggle Button */}
      <ToggleButton activeView={activeView} onToggle={(view) => setActiveView(view)} />

      <Box className={classes.underline} />

      {/* Viewer Content */}
      <ViewerContent
        activeView={activeView}
        OnFullscreenXeokit={handleFullscreenXeokit}
        OnFullscreenVC={handleFullscreenVC}
      />

    </Box>
  );
};

export default InteractiveViewers;